import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { AUDIENCE } from './salesData';
import { AUDIENCE_IMAGE_URL } from '../utils/headMeta';

/** Para quién es: cualquiera que reciba consultas por WhatsApp. */
export function AudienceSection() {
  return <section className="w-full bg-white py-16 sm:py-20" data-id="element-25" data-mp="x07inqm8lre2">
      <div className="mx-auto grid w-full max-w-6xl gap-10 px-5 sm:px-6 lg:grid-cols-[0.9fr_1.1fr] lg:items-center" data-id="element-26" data-mp="wxlappvfp9vb">
        <div data-id="element-27" data-mp="4b081t9idbcg">
          <img src={AUDIENCE_IMAGE_URL} alt="Comerciante respondiendo la consulta de un cliente desde el celular" width={1200} height={800} loading="lazy" decoding="async" className="w-full rounded-3xl object-cover" data-id="element-28" data-mp="4aqrewacsgjf" />
        </div>

        <div data-id="element-29" data-mp="3cpsf282h28dw">
          <SectionTag data-id="element-30" data-mp="3cqaipprgrovu">Para quién es</SectionTag>
          <h2 className="mt-4 font-display text-[1.85rem] font-extrabold leading-tight text-ink sm:text-[2.4rem]" data-id="element-31" data-mp="3hpwsfp832mzw">
            Si te escriben por WhatsApp, es para vos
          </h2>

          <ul className="mt-7 grid gap-x-6 gap-y-4 sm:grid-cols-2" data-id="element-32" data-mp="14cn7f924v7vk">
            {AUDIENCE.map(item => <li key={item.title} className="flex items-start gap-3" data-id="element-33" data-mp="ukzm7pw66n2j">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-wa" aria-hidden data-id="element-34" data-mp="uj6hwh914exp">
                  <CheckIcon className="h-3 w-3 text-ink" strokeWidth={3} data-id="element-35" data-mp="ll45z6nrc1vn" />
                </span>
                <div data-id="element-36" data-mp="gkgjmyah497r">
                  <p className="font-display text-[0.98rem] font-bold leading-snug text-ink" data-id="element-37" data-mp="gjx23ioqjmu9">
                    {item.title}
                  </p>
                  <p className="mt-0.5 font-sans text-[0.87rem] leading-snug text-slate" data-id="element-38" data-mp="7l1vw6loycqy">
                    {item.desc}
                  </p>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}